import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * The `orgId` a new project or price book is stamped with, read from
 * `users/{uid}.orgId` — which only the books' claim sync writes
 * (functions/features/books-claims.js; the rules make it server-owned).
 *
 * Returns `{ orgId }` for a member of an organization and `{}` before the
 * user has one, so callers spread it into the document and the rules fall
 * back to the owner. Read from the profile rather than the ID token because
 * a claim lags a membership by up to an hour (the token lifetime) and the
 * document does not.
 */
export const orgStampFor = async (uid) => {
  if (!uid) return {};
  const snap = await getDoc(doc(db, 'users', uid));
  const orgId = snap.exists() ? snap.data().orgId : null;
  return typeof orgId === 'string' && orgId ? { orgId } : {};
};
